export default __webpack_public_path__ + "static/media/BG-Yellow-0007.0514384f.png";